
export const ORDER_MANAGEMENT_CONSTANTS = {
    DEFAULT_USERS_PER_PAGE: 8,
    DEFAULT_ORDERS_PER_PAGE: 10,
    DEFAULT_SIDEBAR_WIDTH: '400px',
    SIDEBAR_MIN_WIDTH: 300,
    SIDEBAR_MAX_WIDTH_RATIO: 0.8,
    CONTAINER_HEIGHT: '95vh',
    SNACKBAR_DURATION: 6000,
    SEARCH_RESULTS_LIMIT: 100,

    MESSAGES: {
      NO_USER_SELECTED: 'Select a user to view orders'
    }
  } as const;